import React, { PureComponent } from 'react';

export default class Contacts extends PureComponent {
    render() {
        return (
            <div className="static-page">
                <div className="static-page-container">
                    <div className="static-page-header">
                        <div className="static-page-logo">
                            <a href="/">
                                <div className="static-page-logo-image"></div>
                                <div className="static-page-logo-text"></div>
                            </a>
                        </div>
                    </div>
                    <div className="static-page-wrapper">
                        <h1>Contacts</h1>

                        <p>We are working on the content for this page. <br />
                            In case you want to get some information, please contact administrator</p>

                        <p>
                            Email: <a href="mailto:support@manuscript-adminsystem.com">support@manuscript-adminsystem.com</a>  <br />
                            Phone number: <a href="tel:+380992859134">+380992859134</a>
                        </p>

                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/StaticPages/Contacts.jsx